import React from 'react';
import { ScaleIcon, FolderIcon, FileTextIcon, CalendarIcon, UsersIcon, ArrowRightIcon, LayersIcon } from 'lucide-react';
import { mockCases, CaseSummary } from '../data/mockData';
interface CasesPageProps {
  onSelectCase: (caseId: string) => void;
}
export function CasesPage({
  onSelectCase
}: CasesPageProps) {
  return <div className="min-h-screen bg-navy" data-id="element-257">
      {/* Top bar */}
      <div className="border-b border-navy-border bg-[#0A1520]" data-id="element-258">
        <div className="max-w-6xl mx-auto px-8 py-4 flex items-center gap-3" data-id="element-259">
          <div className="bg-accent-amber text-navy p-1.5 rounded-sm" data-id="element-260">
            <ScaleIcon size={20} className="stroke-[2.5]" data-id="element-261" />
          </div>
          <span className="font-bold text-xl tracking-tight text-white" data-id="element-262">
            Geniac
          </span>
          <span className="text-text-muted text-sm ml-1" data-id="element-263">
            Discovery Manager
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-8 py-10" data-id="element-264">
        <div className="mb-8" data-id="element-265">
          <h1 className="text-2xl font-semibold text-white tracking-tight mb-2" data-id="element-266">
            Your Cases
          </h1>
          <p className="text-text-secondary text-sm" data-id="element-267">
            Select a matter to open the discovery workbench.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-268">
          {mockCases.map(c => <CaseCard key={c.id} caseData={c} onSelect={() => onSelectCase(c.id)} data-id="element-269" />)}
        </div>
      </div>
    </div>;
}
function CaseCard({
  caseData,
  onSelect
}: {
  caseData: CaseSummary;
  onSelect: () => void;
}) {
  return <div className="bg-navy-surface border border-navy-border rounded-sm flex flex-col group" data-id="element-270">
      <div className="p-5 flex-1" data-id="element-271">
        {/* Top row: icon + case number */}
        <div className="flex items-start justify-between mb-4" data-id="element-272">
          <div className="bg-navy-elevated border border-navy-border rounded-sm p-2" data-id="element-273">
            <FolderIcon size={18} className="text-accent-amber" data-id="element-274" />
          </div>
          <span className="text-xxs font-medium text-text-muted bg-navy-elevated border border-navy-border px-2 py-1 rounded-sm tracking-wide" data-id="element-275">
            {caseData.number}
          </span>
        </div>

        {/* Case name */}
        <h3 className="text-white font-semibold text-base mb-1 leading-snug" data-id="element-276">
          {caseData.name}
        </h3>
        <p className="text-text-muted text-xs mb-4" data-id="element-277">{caseData.court}</p>

        {/* Stats row */}
        <div className="flex items-center gap-4 text-xs text-text-secondary" data-id="element-278">
          <span className="flex items-center gap-1.5" data-id="element-279">
            <FileTextIcon size={12} className="text-text-muted" data-id="element-280" />
            {caseData.documentCount.toLocaleString()} documents
          </span>
          <span className="flex items-center gap-1.5" data-id="element-281">
            <LayersIcon size={12} className="text-text-muted" data-id="element-282" />
            {caseData.discoverySets} sets
          </span>
          <span className="flex items-center gap-1.5" data-id="element-283">
            <UsersIcon size={12} className="text-text-muted" data-id="element-284" />
            {caseData.parties} parties
          </span>
        </div>
      </div>

      {/* Footer */}
      <div className="px-5 py-3 border-t border-navy-border flex items-center justify-between" data-id="element-285">
        <span className="text-xxs text-text-muted flex items-center gap-1.5" data-id="element-286">
          <CalendarIcon size={11} data-id="element-287" />
          Last accessed {caseData.lastAccessed}
        </span>
        <button onClick={onSelect} className="btn-primary text-xs py-1.5 px-4 flex items-center gap-1.5" data-id="element-288">
          Open Case
          <ArrowRightIcon size={13} data-id="element-289" />
        </button>
      </div>
    </div>;
}